import React, { FC } from 'react';
import promotional10 from '../../../assets/help/promotionalClaimUpload/promotional_10.png';
import promotional11 from '../../../assets/help/promotionalClaimUpload/promotional_11.png';
import promotional2 from '../../../assets/help/promotionalClaimUpload/promotional_2.png';
import promotional3 from '../../../assets/help/promotionalClaimUpload/promotional_3.png';
import promotional4 from '../../../assets/help/promotionalClaimUpload/promotional_4.png';
import promotional5 from '../../../assets/help/promotionalClaimUpload/promotional_5.png';
import promotional6 from '../../../assets/help/promotionalClaimUpload/promotional_6.png';
import promotional7 from '../../../assets/help/promotionalClaimUpload/promotional_7.png';
import promotional8 from '../../../assets/help/promotionalClaimUpload/promotional_8.png';
import promotional9 from '../../../assets/help/promotionalClaimUpload/promotional_9.png';
import { SiteHelpCallback } from '../../../constants';
import { useTranslation } from '../../blocks';
import {
    HelpAlert,
    HelpBody,
    HelpBullet,
    HelpImage,
    HelpIndent,
    HelpStep,
    HelpSubheading,
    HelpTitle,
} from './HelpElements';

const UploadPromotionalClaimHelp: FC<SiteHelpCallback> = () => {
    const { t } = useTranslation('uploadPromotionalClaimHelp');

    return (
        <>
            <HelpTitle>{t('uploadPromotionalClaimHelp_Title')}</HelpTitle>
            <HelpBody>{t('uploadPromotionalClaimHelp_intro')}</HelpBody>
            <HelpIndent>
                <HelpStep step={1} group={'intro'}>
                    {t('uploadPromotionalClaimHelp_common_navigateToUpload_1')}
                </HelpStep>
            </HelpIndent>
            <HelpImage src={promotional2} />
            <HelpImage src={promotional3} />

            <HelpSubheading>{t('uploadPromotionalClaimHelp_prefilledTemplate_title')}</HelpSubheading>
            <HelpBody>{t('uploadPromotionalClaimHelp_purpose')}</HelpBody>
            <HelpStep step={1} group={'prefilled'}>
                {t('uploadPromotionalClaimHelp_prefilled_step1')}
            </HelpStep>
            <HelpIndent>
                <HelpBullet>{t('uploadPromotionalClaimHelp_dateRange_activeInRange')}</HelpBullet>
                <HelpBullet>{t('uploadPromotionalClaimHelp_dateRange_startedInRange')}</HelpBullet>
            </HelpIndent>
            <HelpImage size={'medium'} src={promotional4} />
            <HelpAlert>{t('uploadPromotionalClaimHelp_dateNote')}</HelpAlert>
            <HelpStep step={2} group={'prefilled'}>
                {t('uploadPromotionalClaimHelp_prefilled_step2')}
            </HelpStep>
            <HelpImage size={'medium'} src={promotional5} />
            <HelpStep step={3} group={'prefilled'}>
                {t('uploadPromotionalClaimHelp_prefilled_step3')}
            </HelpStep>
            <HelpIndent>
                <HelpBullet>{t('uploadPromotionalClaimHelp_field_claimNumber')}</HelpBullet>
                <HelpBullet>{t('uploadPromotionalClaimHelp_field_unitsSold')}</HelpBullet>
                <HelpBullet>{t('uploadPromotionalClaimHelp_bestPractice')}</HelpBullet>
            </HelpIndent>
            <HelpImage src={promotional6} />

            <HelpSubheading>{t('uploadPromotionalClaimHelp_emptyTemplate_title')}</HelpSubheading>
            <HelpStep step={1} group={'empty'}>
                {t('uploadPromotionalClaimHelp_emptyTemplate_desc')}
            </HelpStep>
            <HelpImage size={'medium'} src={promotional11} />

            <HelpSubheading>{t('uploadPromotionalClaimHelp_submitClaim_title')}</HelpSubheading>
            <HelpStep step={1} group={'submit'}>
                {t('uploadPromotionalClaimHelp_submit_chooseFile')}
            </HelpStep>
            <HelpImage src={promotional7} />
            <HelpStep step={2} group={'submit'}>
                {t('uploadPromotionalClaimHelp_submit_waitForProcessing')}
            </HelpStep>
            <HelpImage size={'medium'} src={promotional8} />
            <HelpStep step={3} group={'submit'}>
                {t('uploadPromotionalClaimHelp_submit_viewUploadedClaims')}
            </HelpStep>
            <HelpImage src={promotional9} />
            <HelpIndent>
                <HelpBullet>{t('uploadPromotionalClaimHelp_statusSuccess')}</HelpBullet>
                <HelpBullet>{t('uploadPromotionalClaimHelp_statusError')}</HelpBullet>
            </HelpIndent>
            <HelpImage src={promotional10} />
        </>
    );
};

export { UploadPromotionalClaimHelp };
